<div class="back-header">
    <!-- Back Button -->
    <div class="back-icon" (click)="BackHealthDepartmentProfile()">
        <i class="dx-icon dx-icon-chevronleft"></i>
    </div>
    <!-- Title -->
    <div class="back-text">{{DetailsFormTitle}}</div>
</div>
<div class="form-wrapper">
    <div class="input-grid">

        <div class="separate-input-field">
            <label for="NameEn" class="lable">Name</label>
            <dx-text-box id="Name" name="NameEn" [(ngModel)]="Entity.p.name_en" stylingMode="outlined"
                placeholder="Enter Name" [width]="'100%'" class="inputfield">
            </dx-text-box>
        </div>

        <div class="separate-input-field">
            <label for="NameMr" class="lable">देवनागरी</label>
            <dx-text-box id="NameMr" name="NameMr" [(ngModel)]="Entity.p.name_mr" stylingMode="outlined"
                placeholder="Enter Name" [width]="'100%'" class="inputfield">
            </dx-text-box>
        </div>

        <div class="separate-input-field">
            <label for="Designation" class="lable">Designation</label>
            <dx-text-box id="Designation" name="Designation" [(ngModel)]="Entity.p.designation_en" stylingMode="outlined"
                placeholder="Enter Designation" [width]="'100%'" class="inputfield">
            </dx-text-box>
        </div>

        <div class="separate-input-field">
            <label for="Designation" class="lable">Designation in देवनागरी</label>
            <dx-text-box id="Designation" name="Designation" [(ngModel)]="Entity.p.designation_mr" stylingMode="outlined"
                placeholder="Enter Designation" [width]="'100%'" class="inputfield">
            </dx-text-box>
        </div>
        <div class="separate-input-field">
            <label for="SeniorityLevel" class="lable">Seniority Level</label>
            <dx-number-box id="SeniorityLevel" name="SeniorityLevel" [(ngModel)]="Entity.p.seniority_level"
                stylingMode="outlined" (click)="selectAllValue($event)" placeholder="Enter SeniorityLevel"
                [width]="'100%'" class="inputfield">
            </dx-number-box>
            <div>
            </div>

            <dx-file-uploader selectButtonText="Upload Photos" accept="image/*" uploadMode="useForm" [multiple]="true"
                [showFileList]="false" (onValueChanged)="onFileSelect($event)"
                [disabled]="SelectedPhotos.length == MAX_PHOTOS">
            </dx-file-uploader>

            <div class="photo-preview" *ngIf="SelectedPhotos.length">
                <div class="img-wrapper" *ngFor="let photo of SelectedPhotos; let i = index">
                    <img [src]="photo.preview" class="preview-img" />
                    <button class="remove-btn" (click)="removePhoto(i)">×</button>
                </div>
            </div>
        </div>

        <!-- READONLY OVERLAY -->
        <div *ngIf="IsReadOnlyMode" class="readonly-overlay"></div>
    </div>
    <div class="button-section" [align]="'center'" style="margin-top: 5rem">
        <app-cancelbutton text="Cancel" (click)="BackHealthDepartmentProfile()"></app-cancelbutton>
        <dx-button [elementAttr]="{ class: 'save-button' }" (click)="SaveHealthDepartmentProfile()"
            [disabled]="isSaveDisabled" [text]="IsNewEntity ?  'Save' : 'Update'" type="default" stylingMode="contained"
            *ngIf="CanAddOrEdit">
        </dx-button>
    </div>